"use strict";

module.exports = function () {

	var $nav = $('.nav'),
		$overlay = $('.nav__overlay');

	$('.nav__toggle').on('click', navOpen);
	$('.nav__popup-close').on('click', navClose);
	$overlay.on('click', function(e){
		if (!$(e.target).parents('.nav__overlay').length) {
			navClose();
		}
	});

	$(window).on('resize', navClose);

	$(document).keyup(function(e) {
		if (e.keyCode === 27 && $nav.hasClass('nav_open')) {
			navClose();
		}
	});

	function navOpen() {
		$nav.addClass('nav_open');
		$('body').css({
			'overflow': 'hidden'
		});
	}

	function navClose() {
		$nav.removeClass('nav_open');
		setTimeout(function(){
			$('.nav__item_open').removeClass('nav__item_open');
			$('body').css({
				'overflow': 'visible'
			});
		}, 150);
	}

	$('.nav__submenu').next('.nav__link').each(function(){
		var $link = $(this),
			$holder = $link.parent('.nav__item');

		$link.on('click', function(){
			$holder.siblings('.nav__item_open').removeClass('nav__item_open');
			$holder.toggleClass('nav__item_open');
			return false;
		});
	});

	$(document).on('click', function(e){
		if (!$(e.target).parents('.nav').length) {
			$('.nav__item_open').removeClass('nav__item_open');
		}
	});
	
};